import { render, staticRenderFns } from "./relatorio-ia-bot.vue?vue&type=template&id=b67f7508&scoped=true"
import script from "./relatorio-ia-bot.vue?vue&type=script&lang=js"
export * from "./relatorio-ia-bot.vue?vue&type=script&lang=js"
import style0 from "./relatorio-ia-bot.vue?vue&type=style&index=0&id=b67f7508&prod&lang=css"
import style1 from "./relatorio-ia-bot.vue?vue&type=style&index=1&id=b67f7508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67f7508",
  null
  
)

export default component.exports